import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonAnonymous32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPersonAnonymous32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.056 15.073c-.625.417-1.325.7-2.056.835V17a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1h.341a3.517 3.517 0 1 0-3.858-3.5H10.5a5.5 5.5 0 1 1 8.556 4.573M23 23a7 7 0 0 0-3.326-5.96 7.5 7.5 0 0 0 1.673-1.28A8.99 8.99 0 0 1 25 23v4H7v-4a8.99 8.99 0 0 1 3.653-7.24 7.5 7.5 0 0 0 1.673 1.28A7 7 0 0 0 9 23v2h14zm-7-.5a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonAnonymous32);
